/* eslint-disable react/no-array-index-key */
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AGENT_FAQ_TEXT, INSTANT_FAQ_TEXT } from '@propertypal/shared/src/constants/instantValuation';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent, useState } from 'react';
import { useTheme } from 'styled-components';
import { IconBox, Point, PointsGroup, Circle } from './AboutInstantValuation.style';
import { FAQRow, FAQText, FAQs, Wrapper } from './ValuationsSalesPage.style';

interface Props {
  agent: boolean;
}

const AboutInstantValuations: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const [activeFaq, setActiveFaq] = useState('');
  const FAQ_TEXT = props.agent ? AGENT_FAQ_TEXT : INSTANT_FAQ_TEXT;

  const toggleFaq = (title: string) => {
    setActiveFaq(activeFaq === title ? '' : title);
  };

  return (
    <div>
      <PageWrapper containerStyle={{ margin: '60px 0 0 0' }}>
        <SubHeading>It&apos;s as easy as...</SubHeading>

        <PointsGroup>
          <Point>
            <IconBox>
              <Circle>1</Circle>
            </IconBox>

            <div>
              {props.agent && (
                <Text>
                  Answer a few questions about your property and we&apos;ll provide a list of the go-to estate agents in
                  that area.
                </Text>
              )}

              {!props.agent && <Text>Pop in the address and a few other details about the property.</Text>}
            </div>
          </Point>

          <Point>
            <IconBox>
              <Circle>2</Circle>
            </IconBox>

            <div>
              {props.agent && (
                <Text>
                  Select a number of estate agents to arrange an in-person valuation of your home. We recommend you pick
                  at least three.
                </Text>
              )}

              {!props.agent && (
                <Text>
                  Our computer will give you a <strong>FREE</strong> estimated value faster than you can say
                  abracadabra!
                </Text>
              )}
            </div>
          </Point>

          <Point>
            <IconBox>
              <Circle>3</Circle>
            </IconBox>

            <div>
              {props.agent && (
                <Text>
                  Sit back and relax - the estate agents will be in touch to arrange an in-person valuation of your
                  home.
                </Text>
              )}

              {!props.agent && (
                <Text>
                  You&apos;ve got the estimated value, but why stop there? Connect with expert estate agents for the
                  most accurate valuation.
                </Text>
              )}
            </div>
          </Point>
        </PointsGroup>
      </PageWrapper>

      <PageWrapper containerStyle={{ margin: '0 0 60px 0', backgroundColor: '#f5f5f5' }} noMaxWidth>
        <FAQs>
          <Wrapper style={{ flexDirection: 'column' }}>
            <SubHeading>Frequently asked questions</SubHeading>

            {FAQ_TEXT.map((faq) => (
              <FAQRow active={activeFaq === faq.title} key={faq.title}>
                <button onClick={() => toggleFaq(faq.title)} type="button">
                  <div>{faq.title}</div>
                  <FontAwesomeIcon icon={faPlus} color={theme.primary} style={{ fontSize: 24 }} />
                </button>

                <FAQText>
                  {faq.text.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </FAQText>
              </FAQRow>
            ))}
          </Wrapper>
        </FAQs>
      </PageWrapper>
    </div>
  );
};

export default AboutInstantValuations;
